const sortSelect = document.getElementById('js-sort-select');
const filtersForm = document.getElementById('js-filters-form');

/**
 * Select input event handler for sorting inventory
 * @param event
 */
function sortInventory(event) {
  const sortInput = document.getElementById('js-sort-input');

  if (sortInput) {
    sortInput.value = sortSelect.options[sortSelect.selectedIndex].dataset.sort;
    filtersForm.submit();
  }
}

function updateResults(event) {
  let ajaxInputs = ['dsp_make[]', 'dsp_model[]'];
  if (ajaxInputs.includes(event.target.name)) {
    //filtersForm.submit();
  }
}

if (filtersForm) {
  filtersForm.addEventListener('change', updateResults);
}

if (sortSelect) {
  sortSelect.addEventListener('change', sortInventory);
}
